import { CanvasBlockEditor } from './canvas-block-editor'
import type { CanvasBlockSpec } from './use-canvases'

export function StubCanvas({
  specs,
  blocks,
  onChangeBlock,
}: {
  specs: CanvasBlockSpec[]
  blocks: Record<string, string[]>
  onChangeBlock: (blockId: string, items: string[]) => void
}) {
  return (
    <div className="flex flex-col gap-3">
      <p className="text-sm text-muted-foreground" role="status">
        Stub template — the full workshop layout for this type is not built yet. You can still
        capture notes in each section.
      </p>
      <div className="grid gap-3 md:grid-cols-2">
        {specs.map((spec) => (
          <CanvasBlockEditor
            key={spec.id}
            spec={spec}
            items={blocks[spec.id] ?? []}
            onChange={(items) => onChangeBlock(spec.id, items)}
          />
        ))}
      </div>
    </div>
  )
}
